<template>
  <span style="text-align: left">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <v-text-field
        v-bind:value="preLoad(value)"
        v-on:input="(event) => $emit('input', preUpdate(event))"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
        solo
        dark
        :autofocus="getComponentParam('autofocus') ? true : false"
        :mask="getComponentParam('mask')"
        background-color="#fcfcfc"
        :maxlength="
          getComponentParam('maxlength') ? getComponentParam('maxlength') : ''
        "
      ></v-text-field>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <span :class="{ 'text-xs-center': modo == 'list' }">
        {{ displayvalue }}
      </span>
    </template>

    <template v-if="modo == 'filtro'">
      <v-text-field
        height="20"
        class="ma-0 pa-1"
        hide-details
        clearable
        v-on:keyup.enter="onEnter"
        v-bind:value="preLoadFiltro(value)"
        v-on:input="(event) => $emit('input', preUpdateFiltro(event))"
        :mask="getComponentParam('mask')"
        solo
        dark
      ></v-text-field>
    </template>
  </span>
</template>

<script>
try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}

export default {
  extends: _baseComponent,

  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped></style>
